import { useCreateCtx } from '../../../hooks';
import { NavigationContext } from './types';

export const [navigationCtx, NavigationProvider] =
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useCreateCtx<NavigationContext>();
